import axios from "axios";
import { toastr } from "react-redux-toastr";
import config from "../../config/constants";
import {
  loadProcessToken,
  getImportStatus,
  showErrorToaster,
} from "./index";
import {loadFeatureImageAPI} from "./reportAction";
import { event_list, asset_name } from '../../events_prediction_timeline_data';
import {LOAD_LABEL_MANAGER} from "./feedbackActions";
export const ASSETS_EVENT_LOADING = 'ASSETS_EVENT_LOADING';
export const LOAD_DEMO_ASSET_EVENTS = 'LOAD_DEMO_ASSET_EVENTS';
export const LOAD_ASSET_EVENTS_API = 'LOAD_ASSET_EVENTS_API';
export const LOAD_ASSETS_EVENT = 'LOAD_ASSETS_EVENT';
export const SAVE_SELECTED_ASSET = 'SAVE_SELECTED_ASSET';
export const LOAD_EVENT_HISTORY = 'LOAD_EVENT_HISTORY';
export const OPEN_EVENT = 'OPEN_EVENT';
export const SET_ASSET_PREDICTION_FILTER_FIELD_DATA_QUERY = 'SET_ASSET_PREDICTION_FILTER_FIELD_DATA_QUERY';
export const CREATE_EVENT_FEEDBACK = 'CREATE_EVENT_FEEDBACK';
export const REMOVE_ASSET_FILTER = 'REMOVE_ASSET_FILTER';

const assetsListLoading = payload => ({
    type: ASSETS_EVENT_LOADING,
    payload,
})


const loadDemoAssetEvents = (props, dispatch) => {
    const currentPage =  props && props.page ? props.page :1;
    const totalPage = 20;
    dispatch(assetsListLoading(true));
    dispatch({
            type: LOAD_DEMO_ASSET_EVENTS,
            payload: {
                event_list, asset_name, currentPage, totalPage
            }
    });
}

const setAssetPredictionFilterFieldDataQuery = payload => ({
  type: SET_ASSET_PREDICTION_FILTER_FIELD_DATA_QUERY,
  payload
});

const loadAssetEventsAPI = (props, dispatch) => {
    console.log("props in load asset events");
    console.log(props);

    const token = loadProcessToken();
    const page = props && props.page ? props.page :1;
    const perPage = props && props.perPage ? props.perPage : 20;
    const filterFieldData =props && props.filterFieldData ? props.filterFieldData.trim() : '';
    const sortBy = props && props.sortBy ? props.sortBy : '';
    const include_pending_count = props && props.includePendingCcount ? props.includePendingCcount : 0;

    axios.get(
      config.API_URL + 'ai4ai/events?page=' + page + '&per_page=' + perPage + filterFieldData +
      ( sortBy && sortBy.length > 0 ? '&sort_by=' + sortBy : '' ) +
      ( include_pending_count> 0 ? '&include_pending_count=' + include_pending_count : '' )
    )
      .then(({ data }) => {
        if (data){
          data.total_pages = data.total;
          dispatch({
            type: LOAD_ASSET_EVENTS_API,
            payload: data
          });
          dispatch(setAssetPredictionFilterFieldDataQuery(filterFieldData));
          dispatch(assetsListLoading(false));
        }
      })
      .catch(function (error) {
        showErrorToaster(error, "Unknown Error in retrieving assets", "Please refer the console logs for more details on the error.");
      });
}

export const loadAssetEvents = (props, scope) => {
    const demo = false;
    if (demo){
        return (dispatch, getState) => {
            loadDemoAssetEvents(props, dispatch);
        }
    } else {
        return (dispatch, getState) => {
            loadAssetEventsAPI(props,  dispatch);
        }
    }
}


export const loadEventHistory = (props, scope) => (dispatch, getState) => {
  let token = loadProcessToken();
  let url =config.API_URL + 'ai4ai/events/history/'+props.event_id;
  axios.get(url).then(({ data }) => {
    if (data){
      dispatch({
          type: LOAD_LABEL_MANAGER,
          payload: data.label_manager
      });
      dispatch({
        type: LOAD_EVENT_HISTORY,
        payload: data
      });

      loadFeatureImageAPI(data, data.last_location, dispatch);
    }
  }).catch(function (error) {
    showErrorToaster(error, "Unknown Error in retrieving event history", "Please refer to the console logs for more details on the error.");
  });
};

export const openEvent = (props, scope) => (dispatch, getState) => {
  dispatch({
    type: OPEN_EVENT,
    payload: props
  });
};



export const createEventFeedback = (props, scope) => (dispatch, getState) => {
  let token = loadProcessToken();
  axios.put(config.API_URL + 'ai4ai/events/event_review', props)
      .then(({ data }) => {
        dispatch({
          type: CREATE_EVENT_FEEDBACK,
          payload: data.data
        });
        toastr.success('Successfully saved event feedback');
      }).catch(function (error) {
      showErrorToaster(error, "Unknown Error in updating feedback", "Please refer the console logs for more details on the error.");
  });
};

export const removeAssetFilter = payload => ({
  type: REMOVE_ASSET_FILTER,
  payload
});

